import { createFileRoute } from "@tanstack/react-router";
import { RadioServicePage } from "./services_.radio";

export const Route = createFileRoute("/service_/radio-advertising-services")({
  head: () => ({
    meta: [
      {
        title: "Radio Advertising Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Radio Advertising Services That Drive Local & Regional Engagement.",
      },
    ],
  }),
  component: RadioServicePage,
});
